module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/victoria-koslosky-4a0383d1167ac4dad61fe45a6a95e3ed.jpg";